module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7r9n3r-798d974827b409d385f6f3a2e6edc12a.svg";